import React from 'react'
import {Link} from 'react-router-dom'

function Adoption() {


  
  return (
    <section className="adoption-area">
    <div className="container">
      <div className="row align-items-center align-items-xl-end justify-content-center">
        <div className="col-xl-7 col-lg-6 col-md-10 order-0 order-lg-2">
          <div className="adoption-img">
            <img src="img/images/adoption_img.jpg" alt="" />
          </div>
        </div>
        <div className="col-xl-5 col-lg-6">
          <div className="adoption-content">
            <h2 className="title">Avec SafiDog,<br /> chaque chien <span>mérite une adoption et une vie </span>heureuse</h2>
            <p>Chez SafiDog, nous offrons un service complet pour identifier la race de votre chien et obtenir des informations essentielles sur sa santé et son bien-être.</p>
            <Link to="#" className="btn">En savoir plus <img src="img/icon/w_pawprint.png" alt="" /></Link>
          </div>
        </div>
      </div>
    </div>
    <div className="adoption-shape"><img src="img/images/adoption_shape.png" alt="" /></div>
  </section>
  )
}

export default Adoption;
